import _ from 'lodash';
export function mockDevices() {
    const oldEnumerateDevices = navigator.mediaDevices.enumerateDevices.bind(navigator.mediaDevices);
    navigator.mediaDevices.enumerateDevices = () => oldEnumerateDevices().then((devices) => {
        _.remove(devices, (d) => {
            d['deviceId'] === 'default';
        });
        devices.push({
            deviceId: 'mock-videoinput-1',
            kind: 'videoinput',
            label: 'Fake camera',
            groupId: 'mock-group-1',
        });
        devices.push({
            deviceId: 'default',
            kind: 'videoinput',
            label: 'Fake camera Default',
            groupId: 'mock-group-2',
        });
        devices.push({
            deviceId: 'mock-audioinput-2',
            kind: 'audioinput',
            label: 'Fake mic',
            groupId: 'mock-group-3',
        });
        devices.push({
            deviceId: 'default',
            kind: 'audioinput',
            label: 'Fake mic Default',
            groupId: 'mock-group-4',
        });
        devices.push({
            deviceId: 'mock-audioinput-3',
            kind: 'audioinput',
            label: 'Fake mic 2',
            groupId: 'mock-group-5',
        });
        return devices;
    });
}
